import { IService } from "../../../core/api/IService";
import { Service } from "../../../core/impl/Service";
import { Context } from "../../../core/impl/Context";
import { ZoneCapacityManager } from "../manager/ZoneCapacityManager";
import { ZoneCapacityJSONParser } from "../parser/ZoneCapacityJSONParser";
import { NetworkInstancesManager } from "../../../networkinstances/impl/manager/NetworkInstancesManager";
import { NetworkInstance } from "../../../networkinstances/impl/model/NetworkInstance";
import { WorldAssignmentTrackingConstants } from "../../../TrackingConstants";
import { WorldAssignmentErrorCodes } from "../../../error/WorldAssignmentErrorCodes";
import { WorldAssignmentError } from "../../../error/WorldAssignmentError";

export class ZoneCapacitiesController {
    private service: IService;
    private manager: ZoneCapacityManager;

    protected initialize() {
        this.service = new Service(Context.instance.globals.zoneCapacityUrl);
        this.manager = Context.instance.get(ZoneCapacityManager);
    }

    private dispose() {
        if (this.service) {
            this.service.dispose();
            this.service = null;
        }
    }

    public async loadZoneCapacityConfig(trackingCallback?: (state: string) => void) {
        if (trackingCallback) {
            trackingCallback(WorldAssignmentTrackingConstants.ZONE_XML_START);
        }
        return this.service.load()
            .then((payload) => {
                if (trackingCallback) {
                    trackingCallback(WorldAssignmentTrackingConstants.ZONE_XML_END);
                }
                this.onZoneCapacityLoadingComplete(payload);
            })
            .catch(() => {
                throw new WorldAssignmentError(
                    WorldAssignmentErrorCodes.ZONE_CAPACITIES_FAILED_TO_LOAD,
                    "Failed to load zone_capacities.json from " + Context.instance.globals.zoneCapacityUrl
                );
            });
    }

    private onZoneCapacityLoadingComplete = (payload: any) => {
        this.manager.zoneCapacities = ZoneCapacityJSONParser.parse(payload);
    }

    public async initZoneCapacity() {
        let instancesManager: NetworkInstancesManager = Context.instance.get(NetworkInstancesManager);
        for (let i = 0; i < instancesManager.networkInstances.length; i++) {
            let instance: NetworkInstance = instancesManager.networkInstances[i];
            let capacity: any = this.manager.getCapacityForZone(instance.zoneId);
            instance.remainingRegistrationCapacity = capacity;
        }
    }
}
